
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.26 33.377l-8.05 1.68a17.54 17.54 0 00-10.83-11.63 4.46 4.46 0 001.53-4.42c-1-5.94-7.83-1.67-10.43.82a14.48 14.48 0 00-7.41-.93c-2.33.42-3.22 2.83-2.85 5 .4 2.34 1.71 3.09 3.3 3a18.72 18.72 0 00-5.25 16.44c0 .78.29 1.51.7 1.42l39.29-8.2c1.04-.24.83-3.35 0-3.18zm-9.69 2l-7.41 1.54a25.378 25.378 0 00-5.5-10.62l-.15-.14a14.7 14.7 0 0113.06 9.25v-.03zm-20 4.18c-.6-4.46-.17-9.42 2.53-13.11l.75-.14c.22.18.47.37.77.57 3.47 2.38 5.73 6.36 7 10.37l-11.05 2.31zm10.1-20.37c1.07.73.19 1.47-.72 1.63a9.45 9.45 0 01-1.84.08 19.587 19.587 0 01-2.43-.22c.41-.24.82-.47 1.24-.68.86-.42 2.71-1.47 3.71-.78l.04-.03zm-16.14 4.45c-1.06-.74-.19-1.47.73-1.64a9.427 9.427 0 011.84-.07c.81.019 1.619.092 2.42.22-.4.24-.81.47-1.23.68-.95.48-2.79 1.53-3.8.84l.04-.03zm5.93 3.55a26 26 0 00-1.3 12.66l-7.63 1.6a13.26 13.26 0 018.89-14.23l.04-.03z"}})])
          )
        }
      }
    